import React from "react";
import {
    BlockQuote,
    GoToAction,
    Cite,
    Deck,
    Heading,
    ListItem,
    List,
    Quote,
    Slide,
    Text
} from "spectacle";


const OurExpertiseCustomers = () =>
    <div>
        <Heading size={4} textColor="fifth" caps>
            Our Expertise
        </Heading>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            We have been helping leading brands innovate their digital experiences and have worked with headless experience delivery, where experiences are built using modern JavaScript tech, yet still personalized to the visitor.
        </Text>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            We have experience in scaling personalization, going from initial segment based personalization in true individualization, using AI.
        </Text>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            We love data and help you collect and connect the right data, which matters for digital experience optimization; and we make it actionable by delivering the right insights to different set of stakeholders.
        </Text>
        <Text margin="30px 0 0" textColor="primary" textSize={25}>
            We can be your trusted advisors and help you through the noise to stay focused on getting next-gen digital experiences launched.
        </Text>
    </div>

export default OurExpertiseCustomers;


// WEBPACK FOOTER //
// ./src/slides/OurExpertiseCustomers.js